import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  size?: 'md' | 'lg' | 'xl';
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  size = 'lg',
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-display font-bold uppercase tracking-wide transition-all duration-300 overflow-hidden group';
  const variants = {
    primary: 'bg-lime-500 text-dark-900 hover:bg-lime-400 shadow-[0_0_20px_rgba(204,255,0,0.3)] hover:shadow-[0_0_30px_rgba(204,255,0,0.5)]',
    secondary: 'bg-dark-700 text-white border border-dark-600 hover:bg-dark-600 hover:border-lime-500'
  };
  const sizes = {
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base',
    xl: 'px-10 py-5 text-lg md:text-xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const content = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-376">
        {children}
        <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-377" />
      </span>
      {variant === 'primary' && <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-378" />}
    </>;
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className} rounded-xl`;
  if (href) {
    return <motion.a href={href} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={combinedClassName} data-id="element-379">
        {content}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={combinedClassName} {...props} data-id="element-380">
      {content}
    </motion.button>;
}